import { render, staticRenderFns } from "./BasicUserInfo.vue?vue&type=template&id=bb501440&"
import script from "./BasicUserInfo.vue?vue&type=script&lang=js&"
export * from "./BasicUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports